import { DropDownWithDefaultSelect } from "components/base/ActionsDropdown";
import { hasReactHookFormError } from "components/base/ErrorFieldMessage";
import { CustomTitleLabel } from "components/earning/CustomBaseComponments";
import { ConditionTag } from "config/CustomEnums";
import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { connect } from "react-redux";

const SignUpEmailDomainSection = ({
  title,
  fieldBaseName,
}) => {
  const { setValue, watch, control, formState: { errors } } = useFormContext();
  const lookupFieldName = `${fieldBaseName}.lookup`;
  const emailDomainFieldName = `${fieldBaseName}.emailDomain`;
  const emailDomain = watch(emailDomainFieldName)
  const lookup = watch(lookupFieldName) || 'Please select';

  const lookups = [
    ConditionTag.EQUAL_TO,
    ConditionTag.NOT_EQUAL_TO,
  ]

  const dropDownOptions = lookups.map((lookupItem) => ({
    name: lookupItem,
    action: () => {
      setValue(lookupFieldName, lookupItem, { shouldDirty: true, shouldValidate: true });
    },
  }));

  return (
    <div>
      <CustomTitleLabel title={title} />
      <div style={{ display: 'flex' }}>
        <Controller
          control={control}
          name={lookupFieldName}
          rules={{ required: true }}
          render={({ field }) => (
            <DropDownWithDefaultSelect
              actions={dropDownOptions}
              defaultValue={lookup}
              className={hasReactHookFormError(errors, field.name) ? 'error-field' : ''}
            />
          )}
        />
        <Controller
          control={control}
          name={emailDomainFieldName}
          rules={{ required: true }}
          render={({ field }) => (
            <input
              value={emailDomain}
              style={{ width: "400px" }}
              placeholder="Please input email domain. e,g @gmail.com"
              required
              className={`custom-number-input-long ${hasReactHookFormError(errors, emailDomainFieldName) ? 'error-field' : ''}`}
              onChange={(e) => {
                const { value } = e.target
                setValue(emailDomainFieldName, value, { shouldDirty: true, shouldValidate: true });
              }}
            />
          )}
        />
      </div>
    </div>
  );
}
const mapPropsToState = (state) => ({
});

export default connect(mapPropsToState)(SignUpEmailDomainSection);